export enum IntroductionSubjectEnum {
	Unknown = 'Weet ik niet',
	SGT = 'Small Group Training',
	PGT = 'Private Group Training',
	PT = 'Personal Training'
}
